<template>
    <div class="ModalDoutrina">
        <b-modal ref="modal-doutrina" id="modalDoutrina" body-class="m-modal-body" size="xl" :hide-footer="true" :hide-header="true" content-class="wrapper top-flashlight leftside light-xl" modal-class="rbt-modal-box share-modal" centered>
            <h5 class="title"></h5>
            <button class="close-button" data-bs-dismiss="modal" @click="close">
                <i class="feather-x"></i>
            </button>
            <div class="form">
                <div class="row">
                    <div class="col-12" v-if="tipo == 0">
                        <embed src="livro_doutrina.pdf" type="application/pdf" width="100%" height="650px" />
                    </div>
                    <div class="col-12" v-else >
                        <embed src="livro_governanca.pdf" type="application/pdf" width="100%" height="650px" />
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>

    export default {
        name: 'ModalDoutrina',
        data: function () {
            return {
            }
        },
        props: {
            showModal: Boolean,
            tipo: Number,
        },
        methods: {
            load() {

            },

            close() {
                this.$refs['modal-doutrina'].hide();
            }

        },
        created: function () {
            this.load();
        },
        watch: {
            showModal: function () {
                this.$refs['modal-doutrina'].show();
            },
            tipo: function () {
                this.load();
            },
        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* Modal Doutrina */
    .form-control {
        border: 1px solid #474747;
    }

</style>

